import {
  useBuildSignUpUrl,
  usePerfBuildSignUpUrl,
} from "@faire/deprecated-retailer-visitor-shared/components/AppSignUp/useBuildSignUpURL";
import { isSocialBrowser } from "@faire/deprecated-retailer-visitor-shared/lib/user-agent/isSocialBrowser";
import { useSettingPrefetchSignUpIframe } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingPrefetchSignUpIframe";
import { useInjectIframePrefetchCallback } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useInjectIframePrefetch";
import { trackSignupInjectIframeActionCategoryOther } from "@faire/web-api--source/events/signup/actionCategoryOther/injectIframe";
import { useCallback } from "react";

export const useSignUpInjectIframePrefetch = () => {
  const isPrefetchSignUpIframeEnabled = useSettingPrefetchSignUpIframe();
  const signUpUrl = useBuildSignUpUrl();
  const injectIframePrefetchCallback =
    useInjectIframePrefetchCallback(signUpUrl);

  return useCallback(() => {
    // iframes behave poorly on social browsers, so we don't inject them
    injectIframePrefetchCallback(
      !isPrefetchSignUpIframeEnabled || isSocialBrowser(),
      trackSignupInjectIframeActionCategoryOther
    );
  }, [isPrefetchSignUpIframeEnabled, injectIframePrefetchCallback]);
};

// Doesn't support Faire Direct signup query params
export const usePerfSignUpInjectIframePrefetch = (location: {
  pathname: string;
  search: string;
}) => {
  const isPrefetchSignUpIframeEnabled = useSettingPrefetchSignUpIframe();
  const signUpUrl = usePerfBuildSignUpUrl(location);
  const injectIframePrefetchCallback =
    useInjectIframePrefetchCallback(signUpUrl);

  return useCallback(() => {
    injectIframePrefetchCallback(
      !isPrefetchSignUpIframeEnabled || isSocialBrowser(),
      trackSignupInjectIframeActionCategoryOther
    );
  }, [isPrefetchSignUpIframeEnabled, injectIframePrefetchCallback]);
};
